import * as React from 'react';
import { cn } from '../lib/cn.js';

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

/** `.saisie` du kit, nue. Avec un libellé, une aide ou une erreur : `Field`. */
export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, ...props }, ref) => (
    <input ref={ref} className={cn('saisie', className)} {...props} />
  )
);
Input.displayName = 'Input';
